import * as angular from 'angular';
import 'angular-ui-bootstrap';
import * as uib from 'angular-ui-bootstrap';
import '../../templates/partials/confirmmodal.html'

export interface IConfirmOptions {
    okBtnText? : string,
    cancelBtnText? : string,
    replyMessageText? : string
}

export interface IConfirmModalService {
    open(title : string, message? : string, options? : IConfirmOptions) : angular.IPromise<any>;
}

export class ConfirmModalService implements IConfirmModalService {
    static $inject = ['$uibModal'];

    constructor(private $uibModal : uib.IModalService) {

    }

    open(title : string, message? : string, options? : IConfirmOptions) : angular.IPromise<any> {
        return this.$uibModal.open({
            templateUrl : 'partials/confirmmodal.html',
            controller : 'ModalMessageCtrl',
            resolve : {
                message() {
                    return message;
                },
                title() {
                    return title;
                },
                options() {
                    return options || {};
                }
            }
        }).result;
    }
}

export interface IConfirmModalScope extends angular.IScope {
    message : string;
    title : string;
    selected : { item : string };
    okBtnText : string;
    cancelBtnText : string;
    confirmationMessage : string;

    open(size : any) : any;

    ok() : any;

    cancel() : any;

    openSplash(event : any, size : any) : any;
}

export class ModalMessageCtrl {
    static $inject : string[] = ['$scope', '$uibModalInstance', 'title', 'message', 'options'];

    constructor($scope : IConfirmModalScope,
        $uibModalInstance : uib.IModalServiceInstance,
        title : string,
        message : string,
        options : IConfirmOptions) {

        $scope.message = message;
        $scope.title = title;
        $scope.okBtnText = options.okBtnText || 'Ok';
        $scope.cancelBtnText = options.cancelBtnText || 'Cancel';
        $scope.ok = () => {
            $scope.confirmationMessage = options.replyMessageText;
            setTimeout($uibModalInstance.close, 1500);
        };

        $scope.cancel = () => {
            $uibModalInstance.dismiss('cancel');
        };
    }
}


angular.module('Row52.Services.ConfirmModal', ['ui.bootstrap'])
    .service('confirmModalService', ConfirmModalService)
    .controller('ModalMessageCtrl', ModalMessageCtrl);
